// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ba99a973","453":"2b5eb2a1","455":"ab2c1a87"}[chunkId] + ".chunk.js";
};